import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth, SignIn, SignUp } from "@clerk/clerk-react";
import Dashboard from "./Dashboard";
import AcceptInvitationPage from "./AcceptInvitation";
import TermsOfService from "./TermsOfService";
import PrivacyPolicy from "./PrivacyPolicy";

function App() {
  const { isLoaded, isSignedIn } = useAuth();

  // Show loading state while Clerk is initializing
  if (!isLoaded) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Lade...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public legal pages - accessible without authentication */}
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      
      <Route path="/accept-invitation/*" element={<AcceptInvitationPage />} />
      <Route
        path="/sign-in/*"
        element={
          <div className="min-h-screen bg-white flex items-center justify-center px-4">
            <div className="max-w-md w-full">
              <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" />
            </div>
          </div>
        }
      />
      <Route
        path="/sign-up/*"
        element={
          <div className="min-h-screen bg-white flex items-center justify-center px-4">
            <div className="max-w-md w-full">
              <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
            </div>
          </div>
        }
      />
      <Route
        path="/"
        element={
          isSignedIn ? (
            <Dashboard />
          ) : (
            <Navigate to="/sign-in" replace />
          )
        }
      />
      <Route
        path="*"
        element={
          isSignedIn ? (
            <Dashboard />
          ) : (
            <Navigate to="/sign-in" replace />
          )
        }
      />
    </Routes>
  );
}

export default App;
